<template>
  <v-card max-width="850" flat>
    <div>
      <v-list two-line>
        <v-list-item v-if="isCompany">
          <v-list-item-icon>
            <v-icon small>mdi-briefcase-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("report.thgCheckoutPersonalDataCard.company") }}
              <v-btn v-if="!hideEdit" text x-small color="info" @click="goToContactData">{{ $t("edit") }}</v-btn>
            </v-list-item-title>

            <v-list-item-subtitle v-if="!isTaxDeductible">
              {{ $t("report.thgCheckoutPersonalDataCard.isNotTaxDeductable") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="!isResubmitTaxnumber">
              {{ showValueOrDefault(taxNumber, "components.thg.ThgCreateOverviewCard.taxNumber") }}
            </v-list-item-subtitle>
            <div v-else>
              <v-list-item-subtitle>
                {{ $t("components.thg.ThgCreateOverviewCard.isResubmitTaxnumber") }}
              </v-list-item-subtitle>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon small>mdi-email-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("report.thgCheckoutPersonalDataCard.contact")
              }}<v-btn v-if="!hideEdit" text x-small color="info" @click="goToContactData">{{ $t("edit") }}</v-btn>
            </v-list-item-title>
            <v-list-item-subtitle v-if="isCompany">
              {{ showValueOrDefault(company, "components.thg.ThgCreateOverviewCard.company") }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mb-2">
              {{ showValueOrDefault(name, "components.thg.ThgCreateOverviewCard.name") }}
            </v-list-item-subtitle>

            <div v-if="!isResubmitAddress">
              <v-list-item-subtitle>
                {{ showValueOrDefault(street, "components.thg.ThgCreateOverviewCard.street") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ showValueOrDefault(address, "components.thg.ThgCreateOverviewCard.address") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ $t("components.thg.ThgCreateOverviewCard.hintAddress1") }}
              </v-list-item-subtitle>
            </div>

            <div v-else>
              <v-list-item-title>
                {{ $t("components.thg.ThgCreateOverviewCard.isResubmitAddress") }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("components.thg.ThgCreateOverviewCard.hintAddress2") }}
              </v-list-item-subtitle>
            </div>

            <v-list-item-subtitle class="mt-2">
              {{ showValueOrDefault(email, "components.thg.ThgCreateOverviewCard.mail") }}
            </v-list-item-subtitle>

            <v-list-item-subtitle>
              {{ phone }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div v-if="!showCustomerAccount">
          <v-list-item v-if="!isResubmitBankingInformation">
            <v-list-item-icon>
              <v-icon small>mdi-credit-card-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("report.thgCheckoutPersonalDataCard.account")
                }}<v-btn v-if="!hideEdit" text x-small color="info" @click="goToContactData">{{ $t("edit") }}</v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.iban, "components.thg.ThgCreateOverviewCard.iban") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.bank, "components.thg.ThgCreateOverviewCard.bankname") }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ showValueOrDefault(banking.name, "components.thg.ThgCreateOverviewCard.accountOwner") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else>
            <v-list-item-icon>
              <v-icon small>mdi-credit-card-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("components.thg.ThgCreateOverviewCard.resubmitBank")
                }}<v-btn v-if="!hideEdit" text x-small color="info" @click="goToContactData">{{ $t("edit") }}</v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("components.thg.ThgCreateOverviewCard.hintResubmitBank") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-list-item v-else>
          <v-list-item-icon>
            <v-icon small>mdi-credit-card-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("report.thgPayoutConfiguration.customerAccount.titleAlt") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t("report.thgPayoutConfiguration.customerAccount.subtitle1", { company: partnerName }) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-card>
</template>

<script lang="ts">
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { IBankingDto } from "@/store/interface/thg/banking.interface";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { Component, Prop } from "vue-property-decorator";

import ThgContactScreensMixin from "@/components/thg/mixins/ThgContactScreensMixin.vue";
@Component({
  components: {}
})
export default class ThgCheckoutPersonalDataCard extends ThgContactScreensMixin {
  @Prop({ default: false })
  hideEdit?: boolean;

  get banking(): IBankingDto {
    return ThgCreateModule.banking;
  }

  get name(): string {
    return ThgCreateModule.user.firstName + " " + ThgCreateModule.user.lastName;
  }

  get email(): string {
    return ThgCreateModule.contact.email;
  }

  get isCompany(): boolean {
    return ThgCreateModule.isCompany;
  }

  get company(): string {
    return ThgCreateModule.company;
  }

  get isTaxDeductible(): boolean {
    return ThgCreateModule.isTaxDeductible;
  }

  get taxNumber(): string {
    return ThgCreateModule.taxnumber;
  }

  get showCustomerAccount(): boolean {
    return ThgCreateModule.impactType === ImpactTypeEnum.customerAccount;
  }

  showValueOrDefault(value: string, title: string) {
    if (!value.replace(" ", "")) {
      return this.$t("components.thg.ThgCreateOverviewCard.defaultValue", { title: this.$t(title) });
    }

    return value;
  }

  goToContactData() {
    const screenName = this.contactScreens.find((screen) => ReportModule.screenOder.includes(screen));

    if (screenName) {
      this.goToScreen(screenName);
    } else {
      this.$toast.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
      this.$log.error(this.$t("components.thg.ThgCreateOverviewCard.errors.thgcontact"));
    }
  }

  goToScreen(screenName: ReportScreenEnum) {
    ReportModule.setStep(screenName);
    this.$router.push({ name: screenName });
  }

  get phone(): string {
    return ThgCreateModule.contact.phone;
  }

  get isResubmitAddress(): boolean {
    return ThgCreateModule.isResubmitAddress;
  }

  get isResubmitTaxnumber(): boolean {
    return ThgCreateModule.isResubmitTaxnumber;
  }

  get isResubmitBankingInformation(): boolean {
    return ThgCreateModule.isResubmitBankingInformation;
  }

  get street(): string {
    return ThgCreateModule.address.street;
  }

  get address(): string {
    return ThgCreateModule.address.zip + " " + ThgCreateModule.address.city;
  }

  get partnerName(): string {
    return ReportModule.partner.companyName;
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
